/**
 * Allows AngularJS to auto disable a button.
 *
 * Usage example (HTML):
 *
 * <button type="button" class="btn btn-primary btn-loading" ng-click-with-loader="submit()">
 *     <span class="spinner"></span>
 *     <span class="text-default">Save</span>
 *     <span class="text-loading">Loading</span>
 * </button>
 *
 * Usage example (JS):
 *
 * $scope.submit = function () {
 *     var deferred = $q.defer();
 *
 *     asyncFunction(
 *         function onSuccess () {
 *             deferred.resolve();
 *         }, function onError () {
 *             deferred.reject();
 *         }
 *     );
 *
 *     return deferred.promise;
 * };
 */
angular.module('hjApp.ui').directive('ngClickWithLoader', [
    'Notify',
    function (Notify) {
        return {
            restrict: 'A',
            scope: {
                ngClickWithLoader: '&'
            },
            link: function (scope, element, attrs) {
                element.on('click', function (event) {
                    element.addClass('btn-loading');
                    attrs.$set('disabled', true);
                    scope.$apply(function () {
                        scope
                            .ngClickWithLoader(scope, { $event: event })
                            .catch(function () {
                                Notify.error('An error occurred. Please try again.');
                            })
                            .finally(function () {
                                element.removeClass('btn-loading');
                                attrs.$set('disabled', false);
                            });
                    });
                });
            }
        };
    }
]);

angular.module('hjApp.ui').directive('ngSubmitWithLoader', [
    function () {
        return {
            restrict: 'A',
            scope: {
                ngSubmitWithLoader: '&'
            },
            link: function (scope, element) {
                var submitButton = element.find('button[type=submit]');
                var submitting = false;

                element.on('submit', function (event) {
                    if (submitting) {
                        return;
                    }

                    submitButton.addClass('btn-loading');
                    submitting = true;

                    scope.$apply(function () {
                        scope.ngSubmitWithLoader(scope, { $event: event })['finally'](function () {
                            submitButton.removeClass('btn-loading');
                            submitting = false;
                        });
                    });
                });
            }
        };
    }
]);
